import { render, staticRenderFns } from "./e-browser-item.vue?vue&type=template&id=c44c1b5c&scoped=true"
import script from "./e-browser-item.vue?vue&type=script&lang=js"
export * from "./e-browser-item.vue?vue&type=script&lang=js"
import style0 from "./e-browser-item.vue?vue&type=style&index=0&id=c44c1b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44c1b5c",
  null
  
)

export default component.exports